export default __webpack_public_path__ + "static/media/Standard11.7d78603a.png";